import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadAjaxSectionData } from 'routes/home/layouts/India/redux';
import { loadAllAdsFromQueue } from 'helpers/ads/redux';
import throttle from 'lodash.throttle';
import Cookie from 'utils/cookies';
import makeRequest from 'utils/makeRequest';
import _get from 'lodash.get';
import Paginate from 'components/Paginate';
import {
  GEO_CODE_MAPPINNG,
  // TOI_HOMEPAGE_CARDCMS_URL,
  // WEB_INDIA_HP_GA_CAT,
} from 'constants/index';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { toggleLoginBox } from 'components/Login/redux';
import PrimeScreen from 'components/PrimePaymentFlow/PrimeScreen';
// import AdFreeNudge from 'components/AdFreeNudge/AdFreeNudge';
import ErrorBoundary from 'components/ErrorBoundary';
import Link from 'components/Link';
import Image from 'components/Image';
// import WithPopup from 'modules/WithPopup';
import { isPrimeNotActive } from 'utils/primeUtil';
import { loadGeoLocationData } from 'reduxUtils/modules/geo';
import { inViewForReact, fireCustomDimension, isTablet } from 'utils/common';
import {
  getExperimentRefresh,
  refreshEventsClearTimeout,
} from 'utils/experimentUtils';
// import AffiliateWidget from 'components_v2/desktop/AffiliateWidget';
import ElementInView from 'components_v2/common/ElementInView/ElementInView';
//import PodcastWidget from 'components_v2/desktop/PodcastWidget';
// import TimesClubWidgetLoader from 'components_v2/common/TimesClubWidget/TimesClubWidgetLoader';
// import WithPopup from 'modules/WithPopup';
import AffiliatesContent from 'components/AffiliatesContent';
import AffiliatesContentV2 from 'components/AffiliatesContentV2';
import { setPageConfigAndSendIBeatCall } from 'utils/iBeatConfig';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import ThreeWidget from 'components_v2/desktop/ThreeWidget';
// CARD-3692: temporary disabled
// import UtilityBeltV2 from 'components_v2/common/UtilityBeltV2/UtilityBeltV2';
// import { getUtilityBeltData } from 'components_v2/common/UtilityBeltV2/redux';
// import { utilityBeltWrapperStyle } from 'components_v2/common/UtilityBeltV2/UtilityBeltV2.style';
import {
  UserPreferenceContext,
  UseIntersectionObeserver,
  defaultUserPref,
} from '../context';
import AffiliateStories from '../../../components/desktop/AffiliateStories';
// import LazyPlaneLayoutWithAuthor from '../../../components/desktop/PlaneLayoutWithAuthor/LazyPlaneLayoutWithAuthor';
import PlaneLayoutWithAuthor from '../../../components/desktop/PlaneLayoutWithAuthor/PlaneLayoutWithAuthorV2';
// eslint-disable-next-line no-unused-vars
import s from '../../../Home.scss';
import RenderAds from '../../../components/desktop/RenderAds';
import CoverLayout from '../../../components/desktop/CoverLayoutV2';
import RowLayout from '../../../components/desktop/RowLayoutV2';
import SixColumnLayout from '../../../../../components_v2/desktop/SixColumnLayoutV2';
import MasonryLayout from '../../../components/desktop/MasonryLayout';
import Lifestyle from '../../../components/desktop/LifestyleV2/Lifestyle';
// import AssemblyElection from '../../../components/desktop/AssemblyElection/AssemblyElection';
import VideoLayout from '../../../components/desktop/VideoLayoutV2';
import Entertainment from '../../../components/desktop/EntertainmentV2';
import LinksList from '../../../../../components_v2/desktop/LinksList';
import RenderInserts from '../../../components/desktop/RenderInsertsV2/RenderInserts';
import CoronaWidget from '../../../components/desktop/CoronaWidget';
// import CoronaHomePageWidget from '../../../components/common/CoronaHomePageWidget';
import PrimeSlider from '../../../components/desktop/PrimeSlider';
import ThreeColLayout from '../../../components/desktop/ThreeColLayout';
import RowLayoutWithVerticalColumns from '../../../components/desktop/RowLayoutWithVerticalColumns';
import CustomSlider from '../../../components/desktop/CustomSlider';
import CartoonInfo from '../../../components/desktop/CartoonInfo';
import GaanaNbt from '../../../components/desktop/GaanaNbt';
import Infocus from '../../../components/desktop/Infocus';
import TechSection from '../../../components/desktop/TechSection';
// import ETSubscribe from '../../../../../components_v2/common/ETSubscribe';
// import BudgetWidgetHP from '../../../components/common/BudgetWidgetHP/BudgetWidgetHpLoader';
import BudgetNewHPWidget from '../../../components/common/BudgetWidgetHP/BudgetNewHPWidget';
import Iplwidget from '../../../components/desktop/Iplwidget';
import VisualStories from '../../../components/desktop/VisualStories';
import BannerSlider from '../../../../../components_v2/desktop/BannerSlider';
// import DailyPuzzles from '../../../../games/components/common/DailyPuzzles/DailyPuzzles';
import SiteSync from '../../../components/desktop/SiteSync/SiteSync';
import InViewObserver from '../../../../../components/InViewObserver/InViewObserver';
import ElectionLiveBlogs from '../../../../../components_v2/common/ElectionLiveBlogs';
import VocCardSlider from '../../../components/common/VocCardSlider/VocCardSlider';
// import ElectionWidgetMainWrapper from '../../../../../components/ElectionV2/ElectionWidgetMainWrapper/ElectionWidgetMainWrapper';
// const AdfreeNudgeWithPopup = WithPopup(AdFreeNudge);
// const TimesClubWidgetLoaderWithPopup = WithPopup(TimesClubWidgetLoader);

// const utilityBeltStyle = {
//   ...utilityBeltWrapperStyle,
//   utilityBeltStyle: {
//     ...utilityBeltWrapperStyle.utilityBeltStyle,
//     marginTop: '0px',
//   },
// };

class Home extends React.Component {
  constructor() {
    super();
    this.state = {
      contextVal: { ...defaultUserPref },
      thresholds: [10, 750, 1500, 2250],
      isUserLoggedInDecided: false,
    };
    this.scrollGAElements = [];
    this.handledScrollGAElements = {};
    this.refreshExperimentVal = 0;
  }

  setToiAssistWidgetStates = toBeShown => {
    const userSessionCountCookieVal = Cookie.get('userSessionCount')
      ? parseInt(Cookie.get('userSessionCount'), 10) + 1
      : 1;
    const userSessionVal =
      userSessionCountCookieVal < 1000 ? userSessionCountCookieVal : 1;

    const userSessionInterval = this.props.toiAssistUserSessionCount || 5;
    Cookie.set('userSessionCount', userSessionVal, 30, '/');

    this.setState(
      {
        showToiAssistWidget:
          userSessionVal % userSessionInterval === 0 && toBeShown,
      },
      () => {
        this.setState({
          toiAssistWidgetDecided: true,
        });
      },
    );
  };

  isUserLoggedin = () => {
    const { userData } = this.props;
    let isLoggedin = false;
    if (userData && userData.isLoggedIn) {
      isLoggedin = true;
    }
    return isLoggedin;
  };

  setToiAssistWidgetDecision = () => {
    this.setState({
      toiAssistWidgetDecided: true,
    });
  };

  setIsUserLoggedInDecided = () => {
    this.setState({
      isUserLoggedInDecided: true,
    });
  };

  componentDidMount() {
    this.setScrollGAElements();
    // document.addEventListener('visibilitychange', this.visibilityChange);
    window.showAdFreeNudge = this.showForceNudge;
    if (
      typeof window !== 'undefined' &&
      window.sessionStorage &&
      sessionStorage.getItem('planName')
    ) {
      fireCustomDimension(sessionStorage.getItem('planName'), 'dimension33');
    }
    // analyticsWrapper(
    //   'gaAndGrx',
    //   'send',
    //   'event',
    //   window.categoryForGA,
    //   'Landing_NewHomePage',
    //   'INHP',
    //   { nonInteraction: 1 },
    // );
    getExperimentRefresh(this.props.refreshTime);
    this.setContextVal();

    this.throttledGAonScroll = throttle(this.handleGAOnScroll, 100);
    window.addEventListener('scroll', this.throttledGAonScroll);
    if (
      this.state.thresholds &&
      Array.isArray(this.state.thresholds) &&
      this.state.thresholds.length > 0
    ) {
      window.addEventListener('scroll', this.handleGA4Scroll);
    }

    setPageConfigAndSendIBeatCall();

    if (
      this.props.userData &&
      typeof this.props.userData === 'object' &&
      'isLoggedIn' in this.props.userData
    ) {
      this.setIsUserLoggedInDecided();
    }
    if (
      !(
        this.props.toiAssistRhswidgetFlag &&
        this.props.toiAssistRhswidgetFlag === '1'
      )
    ) {
      this.setToiAssistWidgetDecision();
    }
    if (
      this.props.toiAssistRhswidgetFlag &&
      this.props.toiAssistRhswidgetFlag === '1' &&
      this.state.toiAssistWidgetDecided === undefined
    ) {
      if (this.props.isPrime) {
        this.setToiAssistWidgetStates(true);
      } else if (this.props.userData && this.isUserLoggedin()) {
        this.setToiAssistWidgetStates(true);
      } else if (
        this.props.userData &&
        typeof this.props.userData === 'object' &&
        'isLoggedIn' in this.props.userData &&
        !this.isUserLoggedin()
      ) {
        this.setToiAssistWidgetStates(false);
      }
    }

    // this.setdfpkeyvaluepair();
    // CARD-3692: temporary disabled
    // const apiParam = {
    //   user_prime_status: window.App.state.isPrime ? 'prime' : 'non-prime',
    //   code: '/homepage',
    // };
    // this.props.getUtilityData(apiParam);
  }

  showForceNudge = () => {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ showforcenudge: true });
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledGAonScroll);
    refreshEventsClearTimeout();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props &&
      this.props.hpData &&
      this.props.hpData.sections &&
      prevProps &&
      prevProps.hpData &&
      prevProps.hpData.sections &&
      prevProps.hpData.sections.length < this.props.hpData.sections.length
    ) {
      this.props.loadAllAdsFromQueue('', window.location.pathname);
      this.setScrollGAElements();
    }

    if (
      !this.state.isUserLoggedInDecided &&
      this.props.userData &&
      typeof this.props.userData === 'object' &&
      'isLoggedIn' in this.props.userData &&
      !(
        prevProps.userData &&
        typeof prevProps.userData === 'object' &&
        'isLoggedIn' in prevProps.userData
      )
    ) {
      this.setIsUserLoggedInDecided();
    }
    if (
      this.props.toiAssistRhswidgetFlag &&
      this.props.toiAssistRhswidgetFlag === '1' &&
      !this.props.isPrime &&
      this.state.toiAssistWidgetDecided === undefined
    ) {
      if (
        this.props.userData &&
        !(prevProps.userData && prevProps.userData.isLoggedIn) &&
        this.isUserLoggedin()
      ) {
        this.setToiAssistWidgetStates(true);
      } else if (
        this.props.userData &&
        typeof this.props.userData === 'object' &&
        'isLoggedIn' in this.props.userData &&
        !(
          prevProps.userData &&
          typeof prevProps.userData === 'object' &&
          'isLoggedIn' in prevProps.userData
        ) &&
        !this.isUserLoggedin()
      ) {
        this.setToiAssistWidgetStates(false);
      }
    }
  }

  setScrollGAElements = () => {
    try {
      this.scrollGAElements = [
        ...document.querySelectorAll('[data-scrollga]:not([data-scrollga=""])'),
      ];
    } catch (e) {
      // console.log(e);
    }
  };

  setViewGA4Elements = sectionItem => {
    if (
      typeof sectionItem.ga4Type !== 'undefined' &&
      sectionItem.ga4Type !== ''
    ) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: sectionItem?.ga4Type ? sectionItem?.ga4Type : '',
        category: sectionItem?.ga4Category ? sectionItem?.ga4Category : '',
      });
    }
  };

  isElementEdgesVisible = (el, skewFromBottom) => {
    if (el) {
      const rect = el.getBoundingClientRect();
      const { bottom } = rect;
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;

      if (skewFromBottom) {
        return bottom <= windowHeight;
      }

      return bottom <= 0;
    }

    return false;
  };

  handleGAOnScroll = () => {
    const prevTop = 0;
    let currentTop = 0;
    const doc = document.documentElement;
    const action = 'scroll_measure';
    currentTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (currentTop > prevTop) {
      for (let i = 0; i < this.scrollGAElements.length; i += 1) {
        if (
          this.scrollGAElements[i] &&
          inViewForReact(this.scrollGAElements[i], 0, true)
        ) {
          analyticsWrapper(
            'grx',
            'send',
            'event',
            window.categoryForGA,
            action,
            `${this.scrollGAElements[i].getAttribute('data-scrollga')}_View`,
            { nonInteraction: 1 },
          );

          this.scrollGAElements[i].removeAttribute('data-scrollga');
          this.scrollGAElements.splice(i, 1);
          break;
        }
      }
    }
  };
  setScrollGA4State = (threshold, ga4label) => {
    this.setState(
      {
        thresholds: [
          ...this.state.thresholds.filter(item => item !== threshold),
          this.state.thresholds[this.state.thresholds.length - 1] + 750,
        ],
      },
      () => {
        if (ga4label) {
          analyticsWrapper('ga4', {
            event: 'user_scroll',
            type: 'scroll-depth',
            label:
              typeof ga4label === 'string'
                ? ga4label
                : `scroll_${threshold / 750}`,
          });
        }
      },
    );
  };

  handleGA4Scroll = () => {
    // Get the current scroll position
    const scrollPosition = window.scrollY || window.pageYOffset;
    const thresholdsState = this.state.thresholds;
    thresholdsState.forEach(threshold => {
      if (scrollPosition >= threshold) {
        switch (threshold) {
          case 10:
            this.setScrollGA4State(threshold, 'scroll_starts');
            break;
          case 750:
            this.setScrollGA4State(threshold, 'scroll_1');
            break;
          case 1500:
            this.setScrollGA4State(threshold, 'scroll_2');
            break;
          case 2250:
            this.setScrollGA4State(threshold, 'scroll_3');
            break;
          case this.state.thresholds[0]:
            this.setScrollGA4State(this.state.thresholds[0], 1);
            break;
          default:
            break;
        }
      }
    });
  };

  showPrimePopupWidget = propsToPass => {
    const frmapp =
      this.props.query &&
      (this.props.query.frmapp === 'yes' ||
        this.props.query.frmapp === 'shorts');
    if (!frmapp) {
      // return <PrimeScreen {...propsToPass} force />;
      return <PrimeScreen fcap="true" {...propsToPass} />;
    }
    return null;
  };

  shouldShowAdFreeNudge = prcValue => {
    let shouldShow = false;
    if (typeof window === 'object' && isPrimeNotActive(prcValue)) {
      shouldShow = true;
    }
    return shouldShow;
  };

  getPrimeWidgets = () => {
    const { geolocation } = this.props;
    // const prcValue =
    //   userData && userData.prcValue ? this.props.userData.prcValue : 0;

    const geoCode = geolocation ? parseInt(geolocation, 10) : 1;

    if (GEO_CODE_MAPPINNG[geoCode] === 'IN') {
      return (
        <>
          {/* {this.shouldShowAdFreeNudge(prcValue) && (
            <AdfreeNudgeWithPopup
              userData={this.props.userData}
              page="home"
              prcValue={prcValue}
              theme="white_theme"
              showforcenudge={this.state.showforcenudge}
            />
          )} */}

          {this.showPrimePopupWidget({
            componentName: 'BottomToast',
          })}

          {this.showPrimePopupWidget({
            componentName: 'ToiplusSubscribeInlineWidget',
          })}

          {/* {this.showPrimePopupWidget({
            componentName: 'SubscribeNudge',
            theme: 'white_theme',
          })} */}

          {/* {this.showPrimePopupWidget({
            componentName: 'AddFreeSessionLoyalUsers',
            theme: 'white_theme',
          })} */}
        </>
      );
    }
    return null;
  };

  renderInsertsForRow = sectionItem => {
    const { isLoggedIn } = this.props.userData;
    let ga4Type = sectionItem?.ga4Type;
    if (
      sectionItem.items &&
      Array.isArray(sectionItem.items) &&
      sectionItem.items.length > 2 &&
      sectionItem.items[2] &&
      Array.isArray(sectionItem.items[2]?.inserts) &&
      sectionItem.items[2]?.inserts.length > 0 &&
      sectionItem.items[2]?.inserts
    ) {
      ga4Type = sectionItem.items[2]?.inserts[0]?.ga4Type
        ? sectionItem.items[2]?.inserts[0]?.ga4Type
        : ga4Type;
    }
    return (
      <RenderInserts
        key={`${sectionItem.id}_inserts`}
        data={
          sectionItem.items &&
          sectionItem.items[2] &&
          sectionItem.items[2].inserts
        }
        timesTop10={this.props.timesTop10}
        isWapView={this.props.isWapView}
        addMarginTop={sectionItem.id === 'bestsellers'}
        newga={`click-${sectionItem.name}-rhs-`}
        isLoggedIn={isLoggedIn}
        toggleLoginBox={this.props.toggleLoginBox}
        ga4Type={ga4Type}
        ga4Category={sectionItem?.ga4Category}
        //isSubscribed={this.props.isSubscribed}
      />
    );
  };

  // static renderInfocus(data, secname) {
  //   return <Infocus title={data.title} data={data.items} secname={secname} />;
  // }

  setContextVal = () => {
    const geoCity = Cookie.get('geolocation');
    const { contextVal } = this.state;
    if (geoCity) {
      contextVal.geoCity = geoCity;
      this.setState({ contextVal: { ...contextVal } });
      this.setLanguageValInContext(geoCity, false);
    }
  };

  setLanguageValInContext = (
    geoCity,
    setInCookie,
    sectionId,
    //contextValue = this.state.contextVal,
  ) => {
    if (!geoCity) {
      return;
    }
    makeRequest
      .get(
        `https://ematrix.filmipop.com/v2/city/get?city_name=${geoCity}`,
        {},
        'skipfeedengine',
      )
      .then(data => {
        if (data && data.data && data.data.primary_language) {
          const contextVal = {
            geoCity,
            geoLang: data.data.primary_language,
            sectionId,
          };
          this.setState({ contextVal });
          if (setInCookie) {
            let domain = 'indiatimes.com';
            if (document.domain.indexOf('timesofindia.com') >= 0) {
              domain = 'timesofindia.com';
            }
            Cookie.set('geolocation', geoCity, 365, '/', domain);
            Cookie.set('geostate', data.data.state_code, 365, '/', domain);
            if (typeof this.props.loadGeoLocationData === 'function') {
              this.props.loadGeoLocationData();
            }
          }
        }
      });
  };

  render() {
    const {
      hpData = {},
      dataLoading,

      //userData,
      //electionMCDData,
      showToiPlusEntryPoints,
      cardsInsertsLite,
      // cardsJson,
      geoCurrentCountry,
      // clientSideUtilityBeltDetails,
      // serverSideUtilityBeltDetails,
      // utilityBeltData,
      // isWapView,
    } = this.props;
    //const prcValue = userData && userData.prcValue ? userData.prcValue : 0;
    const hpSectionArray = hpData.sections ? hpData.sections : [];
    const { isLoggedIn } = this.props.userData;
    // console.log('userData:;', this.props.userData);

    let componentReturned;
    // let cardInsertCoronaContainer = null;

    return (
      <UserPreferenceContext.Provider
        value={{
          ...this.state.contextVal,
          setLanguageVal: this.setLanguageValInContext,
        }}
      >
        <UseIntersectionObeserver.Provider value>
          <div data-translate-id="cw" data-translate-page="1">
            {/* <ETSubscribe /> */}
            <div id="adsdivLyr" className="adsdivlyr" />
            <div id="tileyeDiv" />
            <div
              id="netspidersosh"
              name="netspidersosh"
              className="adsdivlyr"
            />
            {this.getPrimeWidgets()}
            {hpSectionArray instanceof Array &&
              hpSectionArray.map((sectionItem = {}, indexVal) => {
                switch (sectionItem.tn) {
                  // case 'signals_utilitybelt': {
                  //   if (this.props.isPrime) {
                  //     componentReturned = (
                  //       <UtilityBeltV2
                  //         utilityBeltInfo={utilityBeltData}
                  //         pageCode="/homepage"
                  //         webText="Click for news and views curated for you"
                  //         mwebText="Click for news and views"
                  //         styles={utilityBeltStyle}
                  //         slidesToShow={isWapView ? 4 : 10}
                  //         slidesToScroll={2}
                  //         isWapView={isWapView}
                  //       />
                  //     );
                  //   } else {
                  //     componentReturned = null;
                  //   }
                  //   break;
                  // }
                  case 'col_3_1_2_layout': {
                    let belowStoriesInsertComponent = null;
                    const belowInserts =
                      sectionItem.items &&
                      sectionItem.items[2] &&
                      sectionItem.items[2].below_inserts;
                    if (Array.isArray(belowInserts)) {
                      belowStoriesInsertComponent = (
                        <RenderInserts
                          key={`${sectionItem.id}_inserts_2`}
                          data={belowInserts}
                          isPrime={this.props.isPrime}
                          isWapView={this.props.isWapView}
                          isLoggedIn={isLoggedIn}
                          toggleLoginBox={this.props.toggleLoginBox}
                          newga={`${sectionItem.name}Section_Actions#`}
                          showToiPlusEntryPoints={showToiPlusEntryPoints}
                        />
                      );
                    }
                    componentReturned = (
                      <InViewObserver
                        inViewCallback={() => {
                          this.setViewGA4Elements(sectionItem);
                        }}
                      >
                        <CoverLayout
                          sectionData={sectionItem}
                          key={sectionItem.id}
                          isPrime={this.props.isPrime}
                          isWapView={this.props.isWapView}
                          geoCityData={this.props.geoCityData}
                          renderCallback={this.setScrollGAElements}
                          belowStoriesInsertComponent={
                            belowStoriesInsertComponent
                          }
                          ga4Type={sectionItem?.ga4Type}
                        >
                          <RenderInserts
                            key={`${sectionItem.id}_inserts`}
                            data={
                              sectionItem.items &&
                              sectionItem.items[2] &&
                              sectionItem.items[2].inserts
                            }
                            isPrime={this.props.isPrime}
                            isWapView={this.props.isWapView}
                            isLoggedIn={isLoggedIn}
                            toggleLoginBox={this.props.toggleLoginBox}
                            newga={`${sectionItem.name}Section_Actions#`}
                            showToiPlusEntryPoints={showToiPlusEntryPoints}
                            showToiAssistWidget={this.state.showToiAssistWidget}
                            toiAssistWidgetDecided={
                              this.state.toiAssistWidgetDecided
                            }
                            userData={this.props.userData}
                            isInPageDock={this.props.isInPageDock}
                          />
                        </CoverLayout>
                      </InViewObserver>
                    );
                    break;
                  }
                  // case 'budget': {
                  //   componentReturned = <BudgetWidgetHP data={sectionItem} />;
                  //   break;
                  // }
                  case 'hpbudgetwidget': {
                    componentReturned = (
                      <BudgetNewHPWidget
                        data={sectionItem}
                        isPrime={this.props.isPrime}
                      />
                    );
                    break;
                  }
                  // case 'podcastwidget': {
                  //   componentReturned = (
                  //     <PodcastWidget
                  //       sectionItem={sectionItem}
                  //       key={sectionItem.id}
                  //     />
                  //   );
                  //   break;
                  // }
                  case 'col_4_2_layout': {
                    componentReturned = (
                      <RowLayout
                        csr
                        sectionData={sectionItem}
                        key={sectionItem.id}
                        loadAjaxSectionData={this.props.loadAjaxSectionData}
                        // subSections={sectionItem.items ? sectionItem.items : null}
                        renderInsertsFn={this.renderInsertsForRow}
                        geoCityData={this.props.geoCityData}
                        loadAllAdsFromQueue={this.props.loadAllAdsFromQueue}
                        cardsInsertsLite={cardsInsertsLite}
                        location={this.props.location}
                        hideSeperator={false}
                      >
                        {this.renderInsertsForRow(sectionItem)}
                      </RowLayout>
                    );
                    break;
                  }
                  case 'corona_widget': {
                    componentReturned = (
                      <CoronaWidget data={sectionItem} key={sectionItem.id} />
                    );
                    break;
                  }
                  case 'primeslider': {
                    // const isPrimeNotActiveUser = isPrimeNotActive(prcValue);
                    componentReturned = this.props.showToiPlusEntryPoints ? (
                      <>
                        <InViewObserver
                          inViewCallback={() => {
                            this.setViewGA4Elements(sectionItem);
                          }}
                        >
                          <PrimeSlider
                            key={sectionItem.id}
                            data={sectionItem}
                            isPrime={this.props.isPrime}
                            country={geoCurrentCountry}
                            isWapView={false}
                            userData={this.props.userData}
                          />
                        </InViewObserver>
                      </>
                    ) : null;
                    break;
                  }
                  case 'customslider': {
                    componentReturned = (
                      <CustomSlider key={sectionItem.id} data={sectionItem} />
                    );
                    break;
                  }
                  case 'col_6_layout': {
                    componentReturned = (
                      <SixColumnLayout
                        sectionData={sectionItem}
                        key={sectionItem.id}
                        size={sectionItem.id === 'coronavirusPhoto' && 'small'}
                        gridRequired={sectionItem.gridRequired}
                        subSection={sectionItem.id === 'coronavirusPhoto'}
                      />
                    );
                    break;
                  }
                  case 'masonry_layout': {
                    componentReturned = (
                      <MasonryLayout
                        sectionData={sectionItem}
                        key={sectionItem.id}
                      />
                    );
                    break;
                  }
                  case 'col_3_layout': {
                    componentReturned = (
                      <Lifestyle
                        sectionData={sectionItem}
                        key={sectionItem.id}
                        // footer={Home.renderInfocus(
                        //   sectionItem.keywords,
                        //   `${_get(sectionItem, 'name', '')}Infocus`,
                        // )}
                      />
                    );
                    break;
                  }
                  // case 'col_3_layout_v3': {
                  //   return (
                  //     <AssemblyElection
                  //       sectionData={sectionItem}
                  //       key={sectionItem.id}
                  //       footer={Home.renderInfocus(
                  //         sectionItem.keywords,
                  //         `${_get(sectionItem, 'name', '')}Infocus`,
                  //       )}
                  //     />
                  //   );
                  // }
                  case 'col_3_layout_v2': {
                    componentReturned = (
                      <ThreeColLayout
                        sectionData={sectionItem}
                        key={sectionItem.id}
                        geoCityData={this.props.geoCityData}
                      />
                    );
                    break;
                  }
                  case 'ad': {
                    if (sectionItem.item && sectionItem.item.length > 0) {
                      componentReturned = (
                        <div className={`${s.ctnBannerads} row`}>
                          {sectionItem.item.map((ad, index) => (
                            <InViewObserver
                              inViewCallback={() => {
                                if (ad?.ga4Type) {
                                  analyticsWrapper('ga4', {
                                    event: 'user_shown',
                                    type: `${ad?.ga4Type}`,
                                    category: `${ad?.ga4Category || ''}`,
                                  });
                                }
                              }}
                            >
                              <RenderAds
                                adObject={ad}
                                lazyload={ad.adType !== 'ctn'}
                                key={`${sectionItem.tn}_${indexVal}_${index}`}
                                isWapView={false}
                                adWrapperClassname="col_l_4"
                              />
                            </InViewObserver>
                          ))}
                        </div>
                      );
                      break;
                    }

                    componentReturned = (
                      <InViewObserver
                        inViewCallback={() => {
                          if (sectionItem?.ga4Type) {
                            analyticsWrapper('ga4', {
                              event: 'user_shown',
                              type: `${sectionItem?.ga4Type}`,
                              category: `${sectionItem?.ga4Category || ''}`,
                            });
                          }
                        }}
                      >
                        <RenderAds
                          adObject={sectionItem}
                          lazyload={sectionItem.adType !== 'ctn'}
                          key={`${sectionItem.tn}_${indexVal}`}
                          isWapView={false}
                          adWrapperClass=""
                        />
                      </InViewObserver>
                    );
                    break;
                  }
                  case 'threewidget':
                    return (
                      <ThreeWidget
                        key={sectionItem.tn}
                        data={sectionItem}
                        gaAction="SpotlightBannerWidget_Click"
                        gaLabelPerfix="Spotlight_banner/click/"
                        Ga4Enable={sectionItem.id === 'threewidgets'}
                        isPrime={this.props.isPrime}
                        isUserLoggedInDecided={this.state.isUserLoggedInDecided}
                        userData={this.props.userData}
                      />
                    );
                  case 'bannerslider':
                    return (
                      <BannerSlider
                        key={sectionItem.tn}
                        data={sectionItem}
                        ga4Type={sectionItem?.ga4Type}
                        ga4Category={sectionItem?.ga4Category}
                        gaAction="SpotlightBannerWidget_Click"
                        gaLabelPerfix="Spotlight_banner/click/"
                        onRendered={() => {
                          this.setScrollGAElements.call(this);
                        }}
                      />
                    );
                  case 'banner': {
                    if (sectionItem.item && sectionItem.item.length > 0) {
                      componentReturned = (
                        <div
                          className={`${
                            s.staticbanner
                          } ${sectionItem.className || ''}`}
                        >
                          {sectionItem.border &&
                            sectionItem.border === 'top' && (
                              <InterSectionBorder border={sectionItem.border} />
                            )}
                          <div
                            className={`${s.innerWrapper} ${s.slugbannerouter}`}
                          >
                            {sectionItem.item.map((data, index) => (
                              <Link
                                to={data.wu}
                                data-newga={data.gaData || ''}
                                target={
                                  data.target === '_blank' ? data.target : ''
                                }
                                aria-label={data.gaData}
                              >
                                {data.inviewGa === 'y' &&
                                data.gaCat &&
                                data.gaAc &&
                                data.gaLeb ? (
                                  <ElementInView
                                    gaCategory={data.gaCat}
                                    gaLabel={data.gaLeb}
                                    gaAction={data.gaAc}
                                  >
                                    <Image
                                      key={index}
                                      url={data.imgUrl}
                                      src={data.imgUrl}
                                      target="_blank"
                                      // width={width}
                                      title={data.title || ''}
                                      placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
                                      lazyload
                                      alt="banner img"
                                    />
                                  </ElementInView>
                                ) : (
                                  <Image
                                    key={index}
                                    url={data.imgUrl}
                                    src={data.imgUrl}
                                    target="_blank"
                                    // width={width}
                                    title={data.title || ''}
                                    placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
                                    lazyload
                                    alt="banner img"
                                  />
                                )}
                              </Link>
                            ))}
                            {sectionItem.inserts &&
                              sectionItem.inserts.length > 0 && (
                                <div className={s.slugadboxhp}>
                                  <RenderInserts
                                    key="bannerad_inserts"
                                    data={sectionItem.inserts}
                                    isPrime={this.props.isPrime}
                                    isWapView={this.props.isWapView}
                                    isLoggedIn={isLoggedIn}
                                    toggleLoginBox={this.props.toggleLoginBox}
                                  />
                                </div>
                              )}
                          </div>
                        </div>
                      );
                      break;
                    }

                    componentReturned = (
                      <Image
                        url={sectionItem.imgUrl}
                        src={sectionItem.imgUrl}
                        overridelink={sectionItem.wu}
                        target="_blank"
                        // width={width}
                        title={sectionItem.title || ''}
                        imageClassName={s.bannerimg}
                        placeHolderSrc="https://static.toiimg.com/photo/42706777.gif"
                        lazyload
                        alt="banner img"
                      />
                    );
                    break;
                  }
                  case 'col_4_vertical_2_layout': {
                    componentReturned = (
                      <RowLayoutWithVerticalColumns
                        sectionData={sectionItem}
                        key={sectionItem.id}
                      >
                        <RenderInserts
                          key={`${sectionItem.id}_inserts`}
                          data={
                            sectionItem.items &&
                            sectionItem.items[2] &&
                            sectionItem.items[sectionItem.items.length - 1]
                              .inserts
                          }
                          timesTop10={this.props.timesTop10}
                          isWapView={this.props.isWapView}
                          addMarginTop={sectionItem.id === 'bestsellers'}
                          newga={`${sectionItem.name}Section_Actions#`}
                          isLoggedIn={isLoggedIn}
                          toggleLoginBox={this.props.toggleLoginBox}
                          ga4Type={sectionItem?.ga4Type}
                          ga4Category={sectionItem?.ga4Category}
                          //isSubscribed={this.props.isSubscribed}
                        />
                      </RowLayoutWithVerticalColumns>
                    );
                    break;
                  }
                  case 'visual_story': {
                    return (
                      <VisualStories
                        key={sectionItem.id}
                        sectionData={sectionItem}
                        loadAjaxSectionData={this.props.loadAjaxSectionData}
                        // gaOnscroll={
                        //   sectionItem &&
                        //   sectionItem.name &&
                        //   sectionItem.name === 'News Visual Stories'
                        //     ? 'scroll_measure#toi_visualstories_view'
                        //     : 'scroll_measure#visualstories_view'
                        // }
                      />
                    );
                  }

                  case 'voc_card_Slider': {
                    return (
                      <ErrorBoundary>
                        <VocCardSlider
                          key={sectionItem.id}
                          sectionData={sectionItem}
                          loadAjaxSectionData={this.props.loadAjaxSectionData}
                        />
                      </ErrorBoundary>
                    );
                  }

                  case 'videos_section': {
                    if (
                      sectionItem.items instanceof Array &&
                      sectionItem.items.length > 0
                    ) {
                      componentReturned = (
                        <VideoLayout
                          key={sectionItem.id}
                          sectionData={sectionItem}
                          loadAjaxSectionData={this.props.loadAjaxSectionData}
                          isEtimesVideo={sectionItem.id === 'etimesvideos'}
                        />
                      );
                      break;
                    }
                    componentReturned = null;
                    break;
                  }
                  case 'entertainment': {
                    // const activeSection = sectionItem.items.filter(
                    //   item => item.active,
                    // )[0];

                    componentReturned = (
                      <Entertainment
                        key={sectionItem.id}
                        sectionData={sectionItem}
                        loadAjaxSectionData={this.props.loadAjaxSectionData}
                        geoCityData={this.props.geoCityData}
                        showEntertainmentSectionLoader={
                          this.props.showEntertainmentSectionLoader
                        }
                        isPrime={this.props.isPrime}
                        insertComp={RenderInserts}
                      />
                    );
                    break;
                  }
                  case 'col_6_ad': {
                    componentReturned = (
                      <RenderInserts
                        data={sectionItem.items}
                        key={sectionItem.id}
                        isLoggedIn={isLoggedIn}
                        toggleLoginBox={this.props.toggleLoginBox}
                        newga={`${sectionItem.name}Section_Actions#`}
                      />
                    );
                    break;
                  }
                  case 'keywords': {
                    if (sectionItem.type === 'slider') {
                      componentReturned = (
                        <div
                          className={`light_capsul ${sectionItem.className}`}
                        >
                          <LinksList
                            cssSelector={
                              sectionItem.id === 'infocus2'
                                ? 'link_list_light'
                                : 'hptrendinglist'
                            }
                            sectionData={sectionItem}
                            key={sectionItem.id}
                          />
                        </div>
                      );
                      break;
                    }
                    const secname = `${_get(sectionItem, 'name', '')}Infocus`;
                    componentReturned = (
                      <Infocus
                        className={s.infocuswidth}
                        key={sectionItem.id}
                        data={sectionItem}
                        secname={secname}
                      />
                    );
                    break;
                  }
                  case 'affiliate_content': {
                    componentReturned = (
                      <>
                        {geoCurrentCountry === 'AE' ? (
                          <AffiliatesContentV2
                            type="toi_affiliate_corner_v1"
                            client="affiliates"
                            filters={{
                              pagename: 'home',
                              platform: 'web',
                            }}
                            key={sectionItem.tn}
                            ga4Type={sectionItem?.ga4Type}
                          />
                        ) : (
                          <AffiliatesContent
                            type={sectionItem.affType}
                            filters={{
                              pagename: 'home',
                            }}
                            key={sectionItem.tn}
                            ga4Type={sectionItem?.ga4Type}
                          />
                        )}

                        <AffiliateStories dataURL="/affiliates_library_widgets_feed.cms?feedtype=json&website=toi&platform=web&pagename=home&country=in&type=affiliate_corner_story" />
                      </>
                    );

                    break;
                  }
                  case 'plane_layout_with_author':
                    componentReturned = (
                      <PlaneLayoutWithAuthor
                        sectionItem={sectionItem}
                        key={sectionItem.id}
                        timesTop10={this.props.timesTop10}
                        isWapView={this.props.isWapView}
                        overrideClass={s.opinionSection}
                        toggleLoginBox={this.props.toggleLoginBox}
                        isLoggedIn={isLoggedIn}
                      />
                    );
                    break;
                  case 'cartooninfogph': {
                    componentReturned = (
                      <CartoonInfo
                        key={sectionItem.id}
                        data={sectionItem}
                        ga4Type={sectionItem?.ga4Type}
                        ga4Category={sectionItem?.ga4Category}
                      />
                    );
                    break;
                  }
                  case 'customIframes': {
                    componentReturned = (
                      <GaanaNbt
                        key={sectionItem.id}
                        data={sectionItem}
                        ga4Type={sectionItem?.ga4Type}
                        ga4Category={sectionItem?.ga4Category}
                      />
                    );

                    break;
                  }
                  case 'iframe': {
                    const data = {
                      name: '',
                      tn: sectionItem.tn,
                      dataUrl: sectionItem.dataUrl,
                    };
                    componentReturned = (
                      <RenderInserts data={[data]} key={sectionItem.id} />
                    );
                    break;
                  }
                  case 'gntech': {
                    componentReturned = (
                      <TechSection
                        sectionData={sectionItem}
                        key={sectionItem.id}
                        loadAjaxSectionData={this.props.loadAjaxSectionData}
                        showTechSectionLoader={this.props.showTechSectionLoader}
                        renderInsertsFn={this.renderInsertsForRow}
                        geoCityData={this.props.geoCityData}
                        newga={`${sectionItem.name}Section_Actions#`}
                      >
                        {this.renderInsertsForRow(sectionItem)}
                      </TechSection>
                    );
                    break;
                  }
                  case 'election_liveblog': {
                    componentReturned = sectionItem?.items &&
                      Array.isArray(sectionItem.items) &&
                      sectionItem.items.length > 0 && (
                        <ElectionLiveBlogs
                          sectionData={sectionItem}
                          key={sectionItem.id}
                        />
                      );
                    break;
                  }
                  // TODO: Election Widget
                  // case 'election': {
                  //   return (
                  //     <ErrorBoundary>
                  //       <InViewObserver
                  //         inViewCallback={() => {
                  //           analyticsWrapper('ga4', {
                  //             event: 'user_shown',
                  //             type: `exitpoll_widget`,
                  //           });
                  //         }}
                  //       >
                  //         <div className={s.electionHomePageWraper}>
                  //           <ElectionWidgetMainWrapper
                  //             isHomePage
                  //             isWapView={this.props.isWapView}
                  //             isPowerByAd={this.props.isPowerByAd}
                  //             isPowerByAdActive={this.props.isPowerByAdActive}
                  //             tabs={sectionItem.tabs}
                  //             hideETheading
                  //           />
                  //         </div>
                  //       </InViewObserver>
                  //     </ErrorBoundary>
                  //   );
                  // }
                  case 'ipl_widget':
                    componentReturned = (
                      <Iplwidget
                        key={sectionItem.id}
                        sectionData={sectionItem}
                        apiURL={sectionItem.path}
                        gaEventCategory="-IN-NHP1"
                        isAppView={isTablet()}
                      />
                    );
                    break;
                  default: {
                    componentReturned = null;
                  }
                }
                return [componentReturned];
              })}
            {hpData.pagination && (
              <Paginate
                data={hpData.pagination}
                dataLoading={dataLoading}
                skew={900}
                loadPageCallback={pageNum =>
                  this.props.loadPageCallback(pageNum)
                }
              />
            )}
            {/* <TimesClubWidgetLoaderWithPopup isWapView={false} /> */}
            {this.props.siteSync && <SiteSync config={this.props.siteSync} />}
          </div>
        </UseIntersectionObeserver.Provider>
      </UserPreferenceContext.Provider>
    );
  }
}

const mapDispatchtoProps = dispatch => ({
  loadAjaxSectionData: params => {
    dispatch(loadAjaxSectionData(params));
  },
  loadAllAdsFromQueue: (params, path) => {
    dispatch(loadAllAdsFromQueue(params, path));
  },
  toggleLoginBox: params => {
    dispatch(toggleLoginBox(params));
  },
  loadGeoLocationData: params => {
    dispatch(loadGeoLocationData(params));
  },
  // CARD-3692: temporary disabled
  // getUtilityData: params => {
  //   dispatch(getUtilityBeltData(params));
  // },
});

const mapStateToProps = state => ({
  hpData: state.homepage.data,
  timesTop10: state.timesTop10,
  showEntertainmentSectionLoader: state.homepage.showEntertainmentSectionLoader,
  showTechSectionLoader: state.homepage.showTechSectionLoader,
  dataLoading: state.homepage.dataLoading,
  isPrime: state.isPrime,
  userData: _get(state, 'login.userData', {}),
  geoCityData: state.geo.cityData,

  showToiPlusEntryPoints:
    state.toiplusconfig && state.toiplusconfig.showToiPlusEntryPoints,
  //isSubscribed: state.timesTop10 && state.timesTop10.is_Subscribed,
  geoCurrentCountry: state.geo?.currentCountry,
  toiAssistRhswidgetFlag: _get(
    state,
    'homepage.data.toiAssistRhswidgetFlag',
    undefined,
  ),
  isPowerByAd: _get(state, 'homepage.data.isPowerByAd', undefined),
  isPowerByAdActive: _get(
    state,
    'common.siteConfig.revenue.electionPowerby.isAdActive',
    0,
  ),

  // utilityBeltData: state.utilityBelt?.utilityBeltData,
});

Home.propTypes = {
  routeParams: PropTypes.shape({
    msid: PropTypes.string,
  }),
  hpData: PropTypes.shape({
    sections: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  timesTop10: PropTypes.shape({}),
  loadAjaxSectionData: PropTypes.func.isRequired,
  showEntertainmentSectionLoader: PropTypes.bool,
  showTechSectionLoader: PropTypes.bool,
  dataLoading: PropTypes.bool,
  loadPageCallback: PropTypes.func,
  isWapView: PropTypes.bool,
  loadAllAdsFromQueue: PropTypes.func.isRequired,
  isPrime: PropTypes.bool,
  userData: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
  }).isRequired,
  toggleLoginBox: PropTypes.func,
  //isSubscribed: PropTypes.bool,
  geoCityData: PropTypes.shape({}),

  cardsInsertsLite: PropTypes.objectOf({}),
  showToiPlusEntryPoints: PropTypes.bool,
  location: PropTypes.object,
  showCollage: PropTypes.bool,
  refreshTime: PropTypes.number,
  seokeywords: PropTypes.string,
  siteSync: PropTypes.shape({}),
  geoCurrentCountry: PropTypes.string,
  toiAssistRhswidgetFlag: PropTypes.string,
  toiAssistUserSessionCount: PropTypes.number,
  isInPageDock: PropTypes.bool,
};
Home.defaultProps = {
  // overlayMsid: '',
  routeParams: {},
  showEntertainmentSectionLoader: false,
  showTechSectionLoader: false,
  dataLoading: false,
  loadPageCallback: () => {},
  isWapView: false,
  isPrime: false,
  timesTop10: undefined,
  toggleLoginBox: () => {},
  //isSubscribed: undefined,
  geoCityData: {},

  cardsInsertsLite: {},
  showToiPlusEntryPoints: false,
  location: {},
  showCollage: false,
  refreshTime: 0,
  seokeywords: '',
  siteSync: null,
  geoCurrentCountry: '',
  toiAssistRhswidgetFlag: undefined,
  toiAssistUserSessionCount: 5,
  isInPageDock: false,
};

export default connect(mapStateToProps, mapDispatchtoProps)(Home);

Home.contextTypes = {
  store: PropTypes.object.isRequired,
};
